import "./MHMPressRelease.scss";

export default function ToastIntegrationAnnouncement() {
  const sharer = window.location.href;

  function sendMail() {
    const send = "mailto:?subject=" + encodeURIComponent("MustHaveMenus Joins Toast Partner Ecosystem") + "&body=" + encodeURIComponent("Check out this article! " + sharer);
    window.location.href = send;
  }
    
  return (
    <main className="toast-integration-announcement">
      <section className="one">
        <div className="content">
          <div className="breadcrumb">
            <a href="/content/press">Press</a>
            &nbsp;&nbsp;&gt;&nbsp;&nbsp;
            <b>MustHaveMenus Joins Toast Partner Ecosystem</b>
          </div>
        </div>
      </section>

      <section className="two">
        <div className="content">
          <div className="header">
            <img className="toast-int-img" src="https://timber.mhmcdn.com/site/content/press/MHM&ToastHorizontal.svg" alt="MustHaveMenus & Toast logo"/>
            <h1>MustHaveMenus Joins<br/>Toast Partner Ecosystem</h1>
            <div className="date">September 14, 2023</div>
            <div className="share-links">
              <span>Share this:</span>
              <a href={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(sharer)} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/FacebookBlack.svg" alt="Facebook share"/>
              </a>
              <a href={"https://www.linkedin.com/sharing/share-offsite/?url=" + sharer} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/LinkedInBlack.svg" alt="LinkedIn share"/>
              </a>
              <a href={"https://twitter.com/intent/tweet?text=Check out this article! " + sharer} target="_blank" rel="noreferrer">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/TwitterBlack.svg" alt="Twitter share"/>
              </a>
              <span onClick={sendMail}>
                <img src="https://timber.mhmcdn.com/site/marketing/icons/EmailSimple.svg" alt="Email share"/>
              </span>
            </div>
          </div>

          <div className="article-text">
            <p><b>Bend, OR:</b> Today, MustHaveMenus is excited to announce that it has joined the Toast Partner Ecosystem. This integration will allow restaurants to combine MustHaveMenus' innovative design tools with Toast's Point-of-Sale (POS), empowering restaurants to streamline their menu creation and management processes.</p>

            <p>MustHaveMenus is a menu design tool that provides multi-faceted marketing for restaurants across both print and digital platforms. With a massive library of customizable templates, images, and design elements, MustHaveMenus provides restaurants with the tools they need to create professional-quality menus in minutes.</p>

            <p>Toast is a cloud-based, all-in-one digital technology platform purpose-built for the entire restaurant community. It works with integration partners in its Toast Partner Ecosystem, a curated portfolio of more than 200 partners who deliver specialized technology and services to help restaurant operators increase sales, engage guests, and keep employees happy.</p>

            <p><i>"We are thrilled to welcome MustHaveMenus to the Toast Partner Ecosystem and delighted to offer our customers design and data integration with Toast menu data and MustHaveMenus' design platform,"</i> said Keith Corbin, Senior Director, Business Development from Toast. <i>"By offering this integration with MustHaveMenus, we've made it easier than ever for restaurants to create and sync multiple print and digital menus."</i></p>

            <p><i>"I am very excited about this new integration and the effect it will have on my business,"</i> says Andrea Stup, the co-owner and operator of Memories Charcoal House. <i>"It will save me tons of time when designing new menus. I have been using MustHaveMenus for a few years now, and to have this new feature is a game changer for me!"</i></p>

            <p>By importing menu data into any of over 25,000 customizable restaurant templates, users can avoid manual data entry, streamlining menu creation for customers using both MustHaveMenus and Toast. Restaurant owners and operators can swiftly explore different designs and quickly generate new menus or marketing campaigns. Moreover, this integration is designed to simplify menu management across different platforms by synchronizing customer designs with their existing menu data.</p>

            <p><i>"Our integration with Toast marks a significant milestone for MustHaveMenus,"</i> said Jim Williams, CEO of MustHaveMenus. <i>"By integrating our design tools with Toast's robust menu data capabilities, we are empowering restaurants to effortlessly create, manage, and update their menus. This collaboration embodies our commitment to providing cutting-edge solutions that drive success for our customers."</i></p>

            <p><b>About MustHaveMenus:</b><br/>
            MustHaveMenus is a leading provider of menu design tools, empowering restaurants of all sizes to create stunning menus that reflect their brand and captivate customers. With a range of customizable templates and intuitive design features, MustHaveMenus simplifies the menu creation process, saving time and resources for restaurant owners and operators.</p>
          </div>
        </div>
      </section>

      <section className="three">
        <div className="content">
          <div className="flex">
            <p className="mobile-only"><b>Please direct inquiries to:</b></p>
            <div className="img">
              <div className="jim"/>
            </div>
            <div className="text">
              <p className="desktop-only"><b>Please direct inquiries to:</b></p>
              <h3 className="name">Jim Williams</h3>
              <p className="job-title">CEO<br className="mobile-only"/> @ MustHaveMenus</p>
              <p className="email">jim.williams@musthavemenus.com</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}